import React from "react";

import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import { HorizontalNavBar } from "components/HorizontalNavBar/HorizontalNavBar";
import { RoleName } from "constants/index";
import { Routes } from "constants/routes";
import { useAccountSelector, useUserRoleSelector } from "store";
import { IRoleName } from "store/types";

const CLIENTS_ALLOWED_ROLES: IRoleName[] = [RoleName.Admin, RoleName.Analyst, RoleName.TeamViewer];

export const NavigationTabs = () => {
  const userRole = useUserRoleSelector();
  const enableClientCrm = Boolean(useAccountSelector()?.enable_client_crm);
  const showClientsTab =
    enableClientCrm && (userRole?.name ? CLIENTS_ALLOWED_ROLES.includes(userRole.name) : false);

  return (
    <HorizontalNavBar
      tabs={[
        {
          value: "users",
          label: "Users",
          icon: <PermIdentityOutlinedIcon />,
          to: Routes.users,
          matchRouts: [Routes.users]
        },
        {
          value: "clients",
          label: "Clients",
          icon: <PeopleOutlinedIcon />,
          to: Routes.clients,
          matchRouts: [Routes.clients],
          hidden: !showClientsTab
        }
      ]}
    />
  );
};
